import { useContext, useRef, useState } from "react";
import { LangContext } from "../../context/LangContext";
import TooltipPortal from '../../components/TooltipPortal';
import "./style.css"

import award_icon from '../../assets/svg/laurel_wreath.svg';

function Awards({ serie }) {
    const awardRefs = useRef({});
    const { language } = useContext(LangContext);
    const [activeTooltip, setActiveTooltip] = useState(null);

    return (
        <div className="awards">
            <img
                src={award_icon}
                alt="Award(s)"

                ref={el => awardRefs.current[0] = el}

                onMouseEnter={() => setActiveTooltip(0)}
                onMouseLeave={() => setActiveTooltip(null)}
            />

            <TooltipPortal
                targetRef={{ current: awardRefs.current[0] }}
                show={activeTooltip === 0}
            >
                {serie[`awards_${language}`].map((award, id) => (
                    <li key={id}>{award}</li>
                ))}
            </TooltipPortal>
        </div>
    )
}

export default Awards;